module.exports = __webpack_public_path__ + "static/media/mimi2.82a78335.gif";